<template>
        <tr class="texto">
           <td>{{ncm}}<br>{{item._CeclamExcecao}}</td>
           <td>{{item.CeclamEmenta}}</td>
            <td v-html="this.legislacao">{{legislacao}}</td>
        </tr>
</template>

<script>
    export default {
        props:['item'],
        data(){
            return{
                ncm:null,
                reNCM: /(\d{4})(\d{2})(\d{2})/,
                legislacao:null,
                reLegislacao: /(\D+)(\d+)\/(\d+)(.+)/
            }
        },
         mounted(){
            this.ncm = this.item.CeclamNcm.replace(this.reNCM, "$1\.$2\.$3");
            this.criaLink(this.item._CeclamLegislacao);            
        },
        methods:{      
            criaLink(string){
                console.log(string)
                let ato = string.replace(this.reLegislacao, "$2");
                let anoAto = string.replace(this.reLegislacao, "$3");
                let atoCompleto = string.replace(this.reLegislacao, "$2/$3");
                this.legislacao = string.replace(this.reLegislacao, `<a target='_blanck' href='http://normas.receita.fazenda.gov.br/sijut2consulta/consulta.action?facetsExistentes=&orgaosSelecionados=&tiposAtosSelecionados=72&lblTiposAtosSelecionados=SC&ordemColuna=&ordemDirecao=&tipoAtoFacet=&siglaOrgaoFacet=&anoAtoFacet=&termoBusca=&numero_ato=${ato}&tipoData=2&dt_inicio=&dt_fim=&ano_ato=${anoAto}&x=10&y=9&optOrdem=Publicacao_DESC&p=1'>$1${atoCompleto}$4</a>`);
            }     
        }
    }
</script>

<style scoped>
.texto{
    width: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/ceclamItem.vue